import * as React from 'react';
import { useCloseModal } from '@core/router';

import { ImportDeclarationProvider } from '../context';
import { ImportDeclaration } from '../containers';

export const ImportDeclarationPage = () => {
  const closeModal = useCloseModal();

  const handleClose = React.useCallback(() => {
    closeModal('/@next/declarations');
  }, [closeModal]);

  return (
    <ImportDeclarationProvider onClose={handleClose} onSubmitSucceed={handleClose}>
      <ImportDeclaration />
    </ImportDeclarationProvider>
  );
};
